import {useAppDispatch} from "../../../../../hooks/hooks";
import {useCallback, useState} from "react";
import {getVoucherExpirationAsync} from "../../../../../store/voucherSlice";
import {VoucherExpirationDTO} from "../../../../../types/voucher";

export function useVoucherExpirationGetter() {
    const dispatch = useAppDispatch();
    const [voucherExpiration, setVoucherExpiration] = useState<VoucherExpirationDTO>()

    const getVoucherExpiration = useCallback(
        async (productVoucherIdx: number) => {
            try {
                const result: VoucherExpirationDTO = await dispatch(getVoucherExpirationAsync(productVoucherIdx)).unwrap();
                setVoucherExpiration(result)
            } catch (e) {
                console.error(e);
                throw new Error("getVoucherExpiration occurs an error");
            }
        },
        [dispatch]
    );

    return {
        getVoucherExpiration,
        voucherExpiration,
    };
}
